// @ts-ignore
import React from 'react';
import { DataGridButton, IColumnType, IDataType, SisDataGridColumns } from '../../components/table';

export const Columns = (handleDelete, handleEdit, translate): SisDataGridColumns => [
  {
    dataType: IDataType.string,
    dataField: 'id',
    width: '10%',
    caption: 'Id',
    cssClass: 'dg-align-center',
  },
  {
    dataType: IDataType.string,
    dataField: 'inboxEmail',
    width: '30%',
    caption: 'Inbox email',
  },
  {
    dataType: IDataType.string,
    dataField: 'inboxFolderName',
    width: '30%',
    caption: 'Inbox folder',
  },
  {
    dataType: IDataType.string,
    dataField: 'requestorEmail',
    width: '30%',
    caption: 'Requestor email',
  },

  {
    type: IColumnType.buttons,
    cellRender: (data) => ButtonCell(data, handleDelete, handleEdit, translate),
    width: '15%',
  },
];

const ButtonCell = (cellData, handleDelete, handleEdit, translate) => {
  return (
    <>
      <DataGridButton
        hint={translate!('Delete', '')}
        icon="remove"
        cellData={cellData}
        onClick={handleDelete}
      />
      <DataGridButton
        hint={translate!('Edit', '')}
        icon="edit"
        cellData={cellData}
        onClick={() => handleEdit(cellData)}
      />
    </>
  );
};
